import { useCallback, useState } from 'react';
import { Button, TextField } from '@mui/material';
import { BaseDialog } from '../common';
import { useDialogFormReset } from '../../hooks/useDialogFormReset';

type CreateFolderDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
};

export const CreateFolderDialog = ({ open, onClose, onSubmit }: CreateFolderDialogProps) => {
  const [name, setName] = useState('');
  const resetForm = useCallback(() => setName(''), []);
  const handleClose = useDialogFormReset(onClose, resetForm);

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    resetForm();
  };

  return (
    <BaseDialog
      open={open}
      onClose={handleClose}
      title="Create folder"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!name.trim()}>
            Create
          </Button>
        </>
      }
    >
      <TextField
        autoFocus
        fullWidth
        size="small"
        label="Folder name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSubmit();
        }}
        sx={{ mt: 0.5 }}
      />
    </BaseDialog>
  );
};
